import { excludeForwardProps as o } from "../../utils/excludeForwardProps.js";
import { styled as r } from "@mui/joy";
import e from "@mui/joy/Chip";
import { commonBaseButtonStyles as t } from "./common/commonBaseButtonStyles.js";
const a = r(e, { shouldForwardProp: o("isPrimary") })(({ theme: o2, isPrimary: r2 }) => ({ ...t(o2), backgroundColor: o2.palette.isDarkMode ? o2.palette.neutral[400] : r2 ? o2.palette.primary[500] : o2.palette.neutral[50], span: { color: o2.palette.isDarkMode ? o2.palette.neutral[900] : o2.palette.neutral[50] }, "&:hover": { backgroundColor: "none" } }));
export {
  a as BaseChip
};
//# sourceMappingURL=BaseChip.js.map
